module.exports = __webpack_public_path__ + "media/images/city_img/c_1-49ca53719e63a2417464af5fa3da0e7a.jpg";